import { render } from "./NewPassword.vue?vue&type=template&id=008010c6"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
script.render = render

export default script